module.exports = __webpack_public_path__ + "static/17-3afe842a8d08a236f4ab6f1f8531d42e.jpg";